import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import clientApi from 'api/clientApi'
import IntegrationApi from 'api/integrationApi'
import ruleApi from 'api/ruleApi'
import thresholdsApi from 'api/thresholdsApi'
import rootReducer, { RootState } from './rootReducer'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      clientApi.middleware,

      IntegrationApi.middleware,
      ruleApi.middleware,
      thresholdsApi.middleware
    )
})

export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
export default store
